// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_classes,
  add_classes,
  update_classes,
  delete_classes,
  get_classes_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  classes: [],
  classlist:[],
  classfilterlist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    series:"",
    primary:"",
    high:""
  },
};

// Async Thunks for API Calls
export const fetchClassesList = createAsyncThunk(
    'classes/fetchClasseslist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_classes_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls
export const fetchFilterClassesList = createAsyncThunk(
  'classes/fetchFilterClasseslist',
  async ({school_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_classes_list(school_id,token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async Thunks for API Calls
export const fetchClasses = createAsyncThunk(
  "class/fetchClasses",
  async ({ page, page_size,school_id,filter_fields, token, signal }, { rejectWithValue }) => {

      console.log("filter_fieldsinslice",filter_fields)
    try {
      const response = await get_classes(page, page_size,school_id,filter_fields,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createClass = createAsyncThunk(
  "class/createClass",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_classes(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateClass = createAsyncThunk(
  "class/updateClass",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_classes(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteClass = createAsyncThunk(
  "class/deleteClass",
  async ({ ids,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_classes({ ids },school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const classSlice = createSlice({
  name: 'classes',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,series ,primary,high} = action.payload;
      state.formData = { id, name,series,primary ,high};
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        series:"",
        primary:"",
        high:""
      };
    },
    setClass(state, action) {
      state.classes = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchClassesList.fulfilled, (state, action) => {
        state.classlist = action.payload.data;
      })
      .addCase(fetchClassesList.rejected, (state, action) => {
        state.classlist = [];
      })
      .addCase(fetchFilterClassesList.fulfilled, (state, action) => {
        state.classfilterlist = action.payload.data;
      })
      .addCase(fetchFilterClassesList.rejected, (state, action) => {
        state.classfilterlist = [];
      })
       // Fetch Classes
       .addCase(fetchClasses.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchClasses.fulfilled, (state, action) => {
        state.loading = false;
        state.classes = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchClasses.rejected, (state, action) => {
        state.loading = false;
        state.classes = [];
        state.error = action.payload;
      })

      // Add Class
      .addCase(createClass.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createClass.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createClass.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateClass.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateClass.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateClass.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete Class
      .addCase(deleteClass.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteClass.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteClass.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setClass,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = classSlice.actions;
export default classSlice.reducer;
